import type { HelpFile } from '../../types/help'
import { AccessTimelineTestIds } from '../../../testids/AccessTimelineTestIds'

export const accessTimelineHelp: HelpFile = {
  docPage: '/docs/identity/access-timeline',
  texts: {
    [AccessTimelineTestIds.accessTimeline]:
      'Chronological history of access changes — every grant, revocation, and approval that has shaped an identity\'s effective access.',
    [AccessTimelineTestIds.timelineEmpty]:
      'No access events recorded yet for this identity.',
    [AccessTimelineTestIds.timelineLoading]: null,
  },
}
